import { StatusApi } from './StatusApi';
import { get } from 'svelte/store';
import { api } from '../../../stores/api';
import { captureMessage } from '@sentry/svelte';

export class MonitorSessionStatus {
    private readonly intervalHandler: any;
    private intervalCheckSeconds: number = 20;

    constructor(onLogout: () => void) {
        this.intervalHandler = setInterval(async () => {
            await StatusApi.check(get(api)).catch(error => {
                console.info('Status check failed, onLogout', error);
                // captureMessage('Status check failed, onLogout', { extra: { error } });
                onLogout();
            });
        }, this.intervalCheckSeconds * 1000);
    }

    destroy() {
        clearInterval(this.intervalHandler);
    }
}
